import * as React from 'react'
import MUITextareaAutosize from '@mui/material/TextareaAutosize'

const TextareaAutosize = (props) => <MUITextareaAutosize {...props} />

export default TextareaAutosize
